import React, { useState, useEffect } from "react";
import NavbarVisitor from "../Component/NavbarVisitor";
import axios from "axios";
import { BASE_URL, IMAGE_URL } from "../Component/Baseurl"; // Assuming IMAGE_URL is the base URL for images
import Footer from "../Component/Footer";
import ProfileNavbar from "../Component/ProfileNavbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapLocationDot,
  faEllipsisV,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";


const Follow = () => {
  const [followedEvents, setFollowedEvents] = useState([]); // State to store followed events
  const [loading, setLoading] = useState(true); // State for loading
  const navigate = useNavigate();
  const userId = localStorage.getItem("visitor_id");

  const fetchFollowedEvents = () => {
    if (userId) {
      // Fetch followed events using the API
      axios
        .get(`${BASE_URL}followed-events/${userId}`)
        .then((response) => {
          setFollowedEvents(response.data.followedEvents); // Set the followed events
          setLoading(false); // Set loading to false when data is fetched
        })
        .catch((error) => {
          console.error("Error fetching followed events:", error);
          setLoading(false); // Set loading to false in case of error
        });
    } else {
      console.error("User ID is missing in localStorage");
      setLoading(false); // Set loading to false in case of missing user_id
    }
  };

  useEffect(() => {
    fetchFollowedEvents();
  }, []); // Fetch followed events when the component mounts

  const handleRemoveFollow = (eventId) => {
    if (!userId) {
      console.error("User ID is missing in localStorage");
      return;
    }

    axios
      .post(`${BASE_URL}/unfollow_event`, {
        event_unique_id: eventId,
        user_id: userId,
      })
      .then((response) => {
        console.log("Event unfollowed successfully:", response);
        // After successfully removing the follow, re-fetch the followed events
        fetchFollowedEvents();

        if (followedEvents.length === 1) {
          // navigate("/follow");  
          window.location.reload();
        }


      })
      .catch((error) => {
        console.error("Error unfollowing event:", error);
      });
  };

  return (
    <>
      <NavbarVisitor />
      <section>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3">
              <ProfileNavbar />
            </div>
            <div className="col-md-9">
              <div className="bg-salt mt-3 p-2 py-3 mb-3 text-start">
                <h2 className="text-start hedng">Followed Events</h2>

                {loading ? (
                  <div>Loading...</div> // Show loading state
                ) : followedEvents.length > 0 ? (
                  followedEvents.map((event, index) => (
                    <div className="row" key={index}>
                      <div className="col-md-4">
                        <div>
                          {/* Use dynamic image URL here */}
                          <img
                            src={`${IMAGE_URL}eventFiles/${event.eventbanner}`} // Assuming event.image_url contains the image path
                            className="img-fluid imgevtpro"
                            alt={event.event_name}
                          />
                        </div>
                      </div>
                      <div className="col-md-8">
                        <div className="event-details text-start p-1">
                          <div className="d-flex justify-content-between align-items-center mb-1">
                            <span className="badge bg-gradient-primary etype">
                              Exhibition | {event.event_mode}
                            </span>
                            <div className="dropdown">
                              <button
                                className="btn p-0"
                                type="button"
                                id={`dropdownMenuButton${index}`}
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <FontAwesomeIcon icon={faEllipsisV} />
                              </button>
                              <ul
                                className="dropdown-menu"
                                aria-labelledby={`dropdownMenuButton${index}`}
                              >
                                <li>
                                  <button
                                    className="dropdown-item olak"
                                    onClick={() =>
                                      handleRemoveFollow(event.exhibition_unique_id)
                                    }
                                  >
                                    Remove Follow
                                  </button>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div>
                            <span className="ft-tags">
                              {new Date(
                                event.exhibition_start_date
                              ).toLocaleDateString("en-GB", {
                                weekday: "short", // Abbreviated weekday name (e.g., "Sun")
                                day: "2-digit", // Day of the month with leading zero if necessary
                                month: "short", // Abbreviated month name (e.g., "Jan")
                                year: "numeric", // Full year (e.g., "2024")
                              })}{" "}
                              -{" "}
                              {new Date(
                                event.exhibition_end_date
                              ).toLocaleDateString("en-GB", {
                                weekday: "short",
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })}
                            </span>
                          </div>
                          <h4 className="ft-event">
                            <Link to={`/exhibition/${event.exhibition_slug}`}>
                              {event.exhibition_name}
                            </Link>
                          </h4>

                          <div>
                            <span className="ft-tags"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div>
                    OOPS!! No followed events found.{" "}
                    <Link to="/all-events" className="viewentlink">
                      View Events To Follow
                    </Link>
                  </div> // If no followed events are found
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Follow;
